"use strict";
/* globals module */
/**
 * @module passwordRecoveryClient
 * @description  Password Recovery Client provides an easy way to consume  Password Recovery REST API end-points. In order to obtain needed routes `passwordRecoveryClient` uses `passwordRecoveryRoute`.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var httpApi_1 = require("../../httpApi");
var _1 = require("./");
var PasswordRecoveryClient = /** @class */ (function () {
    function PasswordRecoveryClient(passwordRecoveryRoute, apiClient) {
        this.passwordRecoveryRoute = passwordRecoveryRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(PasswordRecoveryClient.prototype, "routeDefinition", {
        /**
         * Provides direct access to `passwordRecoveryRoute`.
         * @method
         * @example passwordRecoveryClient.routeDefinition.requestReset(data);
         **/
        get: function () {
            return this.passwordRecoveryRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the password recovery requestReset action is completed. This action initiates the password recovery process for the user.
     * @method
     * @param data A password recovery object which contains parameters required for the password retrieval request.
     * @example passwordRecoveryClient.requestReset({
                    challengeIdentifier : '<challenge-identifier>',
                    challengeResponse : '<challenge-response>',
                    recoverUrl : '<recover-url>',
                    username : '<username>'
                })
                .then(function () {
                    // perform success action here
                },
                 function (data) {
                    // perform error handling here
                })
                .finally (function () {});
     */
    PasswordRecoveryClient.prototype.requestReset = function (data) {
        return this.apiClient.post(this.passwordRecoveryRoute.passwordRecovery(), data);
    };
    /**
     * Returns a promise that is resolved once the password reset action is completed. This updates user's password selection.
     * @method
     * @param data Password recovery object used to update user's current password selection.
     * @example passwordRecoveryClient.reset({
                    newPassword : '<new-password>',
                    passwordRecoveryToken : '<password-recovery-token>'
                })
                .then(function () {
                    // perform success action here
                },
                 function (data) {
                    // perform error handling here
                })
                .finally (function () {});
     */
    PasswordRecoveryClient.prototype.reset = function (data) {
        return this.apiClient.put(this.passwordRecoveryRoute.passwordRecovery(), data);
    };
    var _a, _b;
    PasswordRecoveryClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.PasswordRecoveryRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.PasswordRecoveryRoute !== "undefined" && _1.PasswordRecoveryRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], PasswordRecoveryClient);
    return PasswordRecoveryClient;
}());
exports.PasswordRecoveryClient = PasswordRecoveryClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
*/ 
